// apps/web/src/features/bookings/pages/BookingBySlugPage.tsx
import { useParams } from 'react-router-dom';
import { BookingProgressiveFlow } from '../components/progressive-flow/BookingProgressiveFlow';
import { useVenueByPath } from '../../venues/hooks/useVenues';
import { LoadingSpinner } from '../../../components/ui/LoadingSpinner';
import { Box, Alert } from '@mui/material';

/**
 * BookingBySlugPage - Wrapper for progressive booking flow using slug-based URL
 * Accessed via /:stateSlug/:citySlug/:venueSlug/book route
 * Fetches venue by path and renders the progressive flow
 */
export function BookingBySlugPage() {
  const { stateSlug, citySlug, venueSlug } = useParams<{
    stateSlug: string;
    citySlug: string;
    venueSlug: string;
  }>();

  const {
    data: venue,
    isLoading,
    error,
  } = useVenueByPath(stateSlug || '', citySlug || '', venueSlug || '');

  if (isLoading) {
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}
      >
        <LoadingSpinner />
      </Box>
    );
  }

  if (error || !venue) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          p: 3,
        }}
      >
        <Alert severity="error">Failed to load venue details. Please try again.</Alert>
      </Box>
    );
  }

  return <BookingProgressiveFlow venueId={venue.id} basePrice={venue.basePrice} />;
}
